import { LuMonitor, LuPause, LuPlay, LuSmartphone, LuTablet } from "react-icons/lu";
import {
  DashboardMode,
  useDashboardControlsActions,
} from "../../../view_stores/useDashboardControlsStore";
import {
  PreviewMode,
  useProjectPreviewActions,
  useProjectPreviewIsPaused,
  useProjectPreviewMode,
} from "../../../view_stores/useProjectPreviewStore";

export function ProjectPreviewControls() {
  return (
    <div
      className="flex items-center justify-center gap-4 p-2
    bg-dark-surface-primary rounded-lg"
    >
      <OrientationControls />
    </div>
  );
}

function OrientationControls() {
  const { setDashboardMode } = useDashboardControlsActions();
  const previewMode = useProjectPreviewMode();
  const isPaused = useProjectPreviewIsPaused();
  const { setPreviewMode, togglePause } = useProjectPreviewActions();

  function onOrientationChange(orientation: PreviewMode) {
    setDashboardMode(DashboardMode.PREVIEW);
    setPreviewMode(orientation);
  }

  return (
    <div className="flex items-center gap-1">
      <OrientationBtn
        icon={<LuSmartphone size={16} />}
        title="Mobile Portrait"
        onClick={() => onOrientationChange(PreviewMode.MobilePortrait)}
        isSelected={previewMode === PreviewMode.MobilePortrait}
      />
      <OrientationBtn
        icon={<LuSmartphone size={16} className="rotate-90" />}
        title="Mobile Landscape"
        onClick={() => onOrientationChange(PreviewMode.MobileLandscape)}
        isSelected={previewMode === PreviewMode.MobileLandscape}
      />
      <OrientationBtn
        icon={<LuTablet size={16} />}
        title="Tablet"
        isSelected={previewMode === PreviewMode.Tablet}
        onClick={() => onOrientationChange(PreviewMode.Tablet)}
      />
      <OrientationBtn
        icon={<LuMonitor size={16} />}
        title="Desktop"
        onClick={() => onOrientationChange(PreviewMode.Desktop)}
        isSelected={previewMode === PreviewMode.Desktop}
      />
      <div className="w-px h-5 bg-dark-border mx-1" />
      <OrientationBtn
        icon={isPaused ? <LuPlay size={16} /> : <LuPause size={16} />}
        title={isPaused ? "Resume Preview" : "Pause Preview"}
        isSelected={isPaused}
        onClick={togglePause}
      />
    </div>
  );
}

function OrientationBtn({
  icon,
  title,
  isSelected,
  onClick,
}: {
  icon: React.ReactNode;
  title: string;
  isSelected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`p-2 rounded-md transition-colors ${
        isSelected
          ? "text-dark-text bg-dark-surface-secondary"
          : "text-dark-text hover:bg-dark-surface-secondary"
      }`}
      title={title}
    >
      {icon}
    </button>
  );
}
